import { array, id, integer, literal, object, oneOf, string, type Infer } from "./dsl.js";

export const html5File = object({
  path: string({ min: 1, max: 180, pattern: /^(?:[A-Za-z0-9_-][A-Za-z0-9_.-]*\/)*[A-Za-z0-9_-][A-Za-z0-9_.-]*\.(?:html|css|js|json|png|jpg|jpeg|webp|svg|woff2|mp3|ogg|mp4)$/, patternName: "relative HTML5 file" }),
  sha256: string({ pattern: /^[a-f0-9]{64}$/, patternName: "SHA256" }),
  bytes: integer({ min: 1, max: 10 * 1024 * 1024 }),
});

/** Data-only quarantine reference. No raw code, executable URL, or caller-controlled approval. */
export const html5Project = object({
  kind: literal("interactads.html5-project"),
  formatVersion: literal(1),
  layoutId: id(),
  width: integer({ min: 1, max: 8192 }),
  height: integer({ min: 1, max: 8192 }),
  entryPoint: literal("index.html"),
  provenance: oneOf(["codex-sdk", "handwritten-fixture", "recovered-artifact", "openai-api"]),
  validation: oneOf(["pending-runner", "isolated-preview"]),
  manifestSha256: string({ pattern: /^[a-f0-9]{64}$/, patternName: "SHA256" }),
  files: array(html5File, { min: 1, max: 200 }),
});
export type Html5Project = Infer<typeof html5Project>;
